import { Link } from "react-router-dom";

function BreadcrumbComp({ Param1, Param2, Param3, Route1 = "/" }) {
    return (
        <div className="col-12">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={Route1}>
                            <i className="fa-solid fa-house"></i> {Param1}
                        </Link>
                    </li>
                    {Param2 && (
                        <li className="breadcrumb-item">{Param2}</li>
                    )}
                    {Param3 && (
                        <li className="breadcrumb-item active" aria-current="page">
                            {Param3}
                        </li>
                    )}
                </ol>
            </nav>
        </div>
    );
}

export default BreadcrumbComp;